
import { Component, OnInit, OnChanges, SimpleChanges, ɵConsole, TemplateRef, ViewChild } from "@angular/core";
import { VproService } from "./../../service/vpro/vpro.service";
import { Appointment } from "../../models/appointment";
import { Physician } from "../../models/physician";
import { AllPatient } from "src/app/models/patient";
import { Timeoption } from "src/app/models/timeoption";

import {
  NgbDatepickerConfig,
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { DashCred } from "src/app/models/dash";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { sortBy } from "underscore";
import { FormArray, FormBuilder, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { DoctorCalendarComponent } from "src/app/component/doctor-calendar/doctor-calendar.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Checkin } from "src/app/models/scheckin";
import { TrimFormValuesService } from 'src/app/common/trimmingForm';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
declare var $: any;

@Component({
  selector: 'app-adhoc-appt',
  templateUrl: './adhoc-appt.component.html',
  styleUrls: ['./adhoc-appt.component.css']
})
export class AdhocApptComponent implements OnInit {
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  termsUrl = Utils.termsUrl;
  isError: boolean;
  patient = [];
  show = false;
  public model: any;
  public model1: any;
  physician: any;
  pdata = [];
  phydata = [];
  appointment = new Appointment();
  physiciand = new Physician();
  allpatient = new AllPatient();
  dataValue: boolean;
  searchphy: any;
  submitted = false;
  interval: any;
  patientId: any;
  selectButtonName: string = "SELECT PATIENT";
  phyId: any;
  timer: any;
  appoint: string;
  showdropdown: any;
  dataOfPatient: any;
  birth: any;
  patid: any;
  firstName: string;
  lastName: string;
  isLoading: boolean;
  add: any;
  cont: any;
  data: any;
  message: any;
  patientIdOf: any;
  patientIdBasedData: AllPatient;
  appointmentForm: any;
  option = [new Timeoption("08.00 AM")];
  reset: any;
  myTime = this.option[0];
  index: any;
  preventSimpleClick = false;
  //let delay = 200;
  array: [];
  dcred = new DashCred();
  chkdet: any;
  selectPhysician: boolean;
  org_code: any;
  time1: any = { hour: 13, minute: 30 };
  meridian: Boolean = true;
  currentDate = Utils.maxDate;
  scheduleAppointmentForm: FormGroup;
  AppointmentType = Utils.APPOINTMENT_TYPE;
  termsAndCondition: boolean = true;
  checkin = new Checkin();
  forms = {
    patstats: null,
    reasonForm: null,
  };
  statslist: any = [];
  pat_stats: UntypedFormArray;
  cur_appointment: any;
  cur_appointment_pat: number;

  public workingHours = [];
  // exclude days
  excludeDays: number[];
  cur_day: any;
  drid: number;
  constructor(
    private fb: UntypedFormBuilder,//new
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private service: VproService,
    config: NgbDatepickerConfig,
    private modal: NgbModal,
    // calendar: NgbCalendar,
    private utils: Utils,
    private router: Router,
    private route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private trimFormValuesService: TrimFormValuesService,
  ) {
    this.forms.reasonForm = this._formBuilder.group({
      reasons: [""],
    });
  }
  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  ngOnInit(): void {

    this.getOrgDet(localStorage.getItem("LogUsr"));
    this.getStatsList()
    this.scheduleAppointmentForm = this._formBuilder.group({
      drid: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: [null],
      startTime: [Utils.timesNow, Validators.required],
      endTime: [Utils.constructTime(Utils.timesNow, Utils.defaultEndTimeAddon)]
    });
    // this.getAppointment();

    this.getDefaultWorkingHours();

  }

  onDateSelection(date: NgbDate, datepicker: any) {

    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;

    } else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      console.log(" this.fromDate", this.fromDate)
      console.log(" this.toDate", this.toDate)
      datepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  dateTimeChangeEvent(ev = null) {
    let { startTime, startDate, endTime } = this.scheduleAppointmentForm.value;
    if (endTime) {
      this.validateEndTime();
    }
    else {
      this.scheduleAppointmentForm.patchValue({
        endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
      })
    }
    let isInvalid = Utils.validateStartTime(startTime, startDate);

    if (isInvalid) {
      this.scheduleAppointmentForm.controls['startTime'].setErrors({ 'invalidStartTime': isInvalid })
    }
    else {
      this.scheduleAppointmentForm.controls['startTime'].setErrors(null)
    }
  }

  validateEndTime(e = null) {
    let { startTime, endTime } = this.scheduleAppointmentForm.value;
    let isInvalid = Utils.validateEndTime(startTime, endTime);
    if (isInvalid) {
      this.scheduleAppointmentForm.controls['endTime'].setErrors({ 'invalidEndTime': true })
    }
    else {
      this.scheduleAppointmentForm.controls['endTime'].setErrors(null)
    }
  }

  getAllPhysicians() {
    try {
      let searchFields = { org_code: this.org_code };
      let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

      if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
        searchFields['u_id'] = parseInt(localStorage.getItem('uid'));
      }
      this.service.fetchPhysicians(searchFields, `?test_user=true`).subscribe((result: Physician[]) => {
        this.physician = result['result'];
        this.physician = this.physician.map(p => {
          p.fullname = `${p.first_name} ${p.last_name}`;
          return p;
        });
        console.log("iooooooooooooooououou", this.physician);

        this.org_code = this.physician[0].org_code;

        console.log("this.org_code", this.org_code);
      });
    }
    catch (e) {
      console.log(e);
    }
  }
  getDefaultWorkingHours() {
    let drid = JSON.parse(localStorage.getItem("uid"));
    this.spinner.show();
    this.service.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          //console.log("this.workingHours", this.workingHours)
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
            if (!x.start_time.hour && !x.end_time.hour) {
              this.excludeDays.push(x.day)
            }
          });
        }
        console.log("getWorkingHours", this.workingHours);
        console.log("excludeDays", this.excludeDays);
        const today = new Date();
        const dayOfWeek = today.getDay(); // Sunday - 0, Monday - 1, ..., Saturday - 6

        const todayInfo = this.workingHours.find(day => day.day === dayOfWeek);
        console.log("todayInfo", todayInfo)
        this.cur_day = todayInfo ? todayInfo.Checked : null;
        console.log("cur_day", this.cur_day)
        if (this.cur_day) {
          this.spinner.hide();
          this.showToast('error', "   Physician Not Available.   ");
          return null;
        }

      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }
  fetchPatients(searchFields) {


    console.log("inside fetchPatients -org_code", this.org_code);
    try {
      searchFields.name = (searchFields.name && searchFields.name.length > 0) ? searchFields.name : null;
      searchFields.pid = (searchFields.pid && searchFields.pid.length > 0) ? searchFields.pid : null;
      if (this.fromDate == null) {
        searchFields['fromDate'] = null
      }
      if (this.toDate == null) {
        searchFields['toDate'] = null
      }
      if (this.fromDate) {
        searchFields['fromDate'] = this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day
      }
      if (this.toDate) {
        searchFields['toDate'] = this.toDate.year + "-" + this.toDate.month + "-" + this.toDate.day
      }
      searchFields.org_code = this.org_code;
      this.trimFormValuesService.trimValues(searchFields);
      this.spinner.show();
      this.service.fetchPatients(searchFields).subscribe((result: AllPatient[]) => {
        this.pdata = result;
        this.spinner.hide();
        console.log("this.pdata1111111", this.pdata)
        this.getCrtAppointment();
        this.pdata = sortBy(this.pdata, 'first_name'); // Data Sorter via underscore.js
        for (let i = 0; i < this.pdata.length; i++) {
          this.pdata[i].name = this.pdata[i].first_name.trim() + ' ' + this.pdata[i].last_name.trim();
          this.pdata[i].avatarimg = this.pdata[i].ppurl.substring(this.pdata[i].ppurl.lastIndexOf('/') + 1);
        }

      })
    }
    catch (e) {
      this.spinner.hide();
      console.log(e);
    }
  }


  getCrtAppointment() {
    console.log("function start")
    let standardDbDaateFormat = this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day;
    let standardDbTimeFormat = Utils.timesNow.hour + ":" + Utils.timesNow.minute + ":" + parseInt(moment().format("ss"));
    console.log("standardDbDaateFormat", standardDbDaateFormat)
    console.log("standardDbTimeFormat", standardDbTimeFormat)
    let data = {
      org_code: localStorage.getItem("orgcode"),
      drid: JSON.parse(localStorage.getItem("uid")),
      current_date: standardDbDaateFormat,
      current_time: standardDbTimeFormat
    }
    console.log("this.data", data)
    this.spinner.show();
    this.service.getCurrentAppointment(data).subscribe(res => {
      this.cur_appointment = res;
      console.log("this.cur_appointment", this.cur_appointment.length)
      if (this.cur_appointment.length) {
        this.pdata.forEach(x => {
          x.Checked = this.cur_appointment.some(y => y.pid === x.pid);
        });
      }


      this.spinner.hide();

      console.log("pdata", this.pdata)

    }, error => {
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    });
  }
  getOrgDet(usereid: string) {
    try {
      this.spinner.show();
      this.service.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.org_code = res[0].org_code;
          console.log("IN ONINT::", this.org_code);
          this.spinner.hide();
          this.getAllPhysicians();
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }


  clearSearch() {
    this.appointment["name"] = null;
    this.appointment["pid"] = null;
  }
  /* function that empties the above result*/
  empty() {
    this.pdata.length = 0;
  }

  /**function patientSelection for select the patient */
  patientSelection(data) {
    console.log("patient selection", data);
    this.patientIdOf = data;
    this.pdata.filter(element => {
      if (element["pid"] == this.patientIdOf) {
        document.getElementById(element["pid"]).innerHTML = "SELECTED";
        this.patientIdBasedData = element;
        // this.getAppointment(this.patientIdBasedData)
      }
      else {
        document.getElementById(element["pid"]).innerHTML = "SELECT PATIENT"
      }
    });
    this.selectPhysician = true;

  }

  getToBottom() {
    setTimeout(x => {
      document.documentElement.scrollTop = document.documentElement.scrollHeight;
    }, 1000)
  }

  getToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  getStatsList() {
    this.service.getstatList().subscribe(
      (res) => {
        this.statslist = res;
        if (!this.statslist) {
          console.log("this.statslist", this.statslist)
          for (let stats of this.statslist) {
            this.pat_stats = this.forms.patstats.get("pat_stats") as UntypedFormArray;
            this.pat_stats.push(this.addStats(stats.id));
          }
        }
      },
      (error) => { }
    );
  }
  addStats(id): UntypedFormGroup {
    return this.fb.group({
      stats_id: [id],
      stats_value: [null],
    });
  }
  addAdhocSchedule(data2) {
    let { day: startDay, month: startMonth, year: startYear } = this.currentDate;
    this.drid = parseInt(localStorage.getItem("uid"));
    let data = {
      reason: "Adhoc appointmnet",
      type: this.AppointmentType.IN_PERSON,
      pid: this.patientIdBasedData.pid,
      drid: JSON.parse(localStorage.getItem("uid")),
      aptname: `Consultation : ${this.patientIdBasedData.first_name} ${this.patientIdBasedData.last_name}`,
      apdate: startYear + "-" + startMonth + "-" + startDay,
      aptime: this.scheduleAppointmentForm.value.startTime.hour + ':' + this.scheduleAppointmentForm.value.startTime.minute,
      uid: JSON.parse(localStorage.getItem("uid")),
      createdat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day
    };
    console.log("dataaa", data);
    this.spinner.show();
    this.service.addAdhocSchedule(data).subscribe(
      (res: any) => {
        let { message, aid } = res;
        console.log("aidddddddddddddddd", aid)
        var today = new Date();
        var date = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();
        var current_date = year + '-' + month + '-' + date;

        let datas = {
          patient_checkin_stats: this.statslist,
          // ...this.forms.patstats.value,
          //...this.forms.reasonForm.value, 
          //in above code array key is 'reasons' now we want toc hange 'reason'
          //we can use like this instead of the above line
          reason: "Adhoc appointmnet checkin",
          aid: parseInt(aid),

        };
        if (datas.patient_checkin_stats && datas.patient_checkin_stats.length > 0) {
          datas.patient_checkin_stats.forEach((x, index) => {
            x.stats_std_val = null;
            x.aid = parseInt(aid);
            x.pid = this.patientIdBasedData.pid;
            x.stats_date_time = current_date;
            x.stats_id = x.id;
            x.stats_by = this.drid
            delete x.id;
            delete x.stats_comp;
            delete x.stats_name;
            delete x.stats_std_uom;
            delete x.stats_std_val_from;
            delete x.stats_std_val_to;
            delete x.stats_std_value;
            delete x.stats_type;
          });
        }
        console.log("DATA", datas);
        this.spinner.show();
        this.service.saveCheckin_stats(datas).subscribe(
          () => {
            this.checkin['chkinby'] = this.drid
            this.service.Checkin_s(aid, this.checkin).subscribe((result) => {
              console.log("/phydash/" + 1368 + "?cid=" + 5249)
              // let consult_screen = "/appointment/consultation"
              let consult_screen = "/phydash/" + this.patientIdBasedData.pid
              this.router.navigate([consult_screen], {
                queryParams: { cid: aid }
              });
              console.log("consult_screen", consult_screen)
              this.spinner.hide();
            }, (err) => {
              console.log(err);
            });
          },
          (error) => {
            this.spinner.hide();
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3500,
            });
            Toast.fire({
              type: "error",
              title: "Something went wrong. Please try again later.",
            });
          }
        );
      },
      err => {
        this.spinner.hide();
        console.log(err);
        let message = "Something wrong. Couldn't schedule appointment.";
        if (err && err.error && err.error.error) {
          this.showToast('error', err.error.error);
          return;
        }
        this.showToast('error', message);
      }
    );
  }
  resetForm(form) {
    form.reset();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  reload() {
    location.reload();
  }

  openCalendarMOdal() {
    const modalRef = this.modalService.open(DoctorCalendarComponent, { backdropClass: 'modal-backdrop', size: 'lg', centered: true, backdrop: 'static' });

    modalRef.componentInstance.drid = this.scheduleAppointmentForm.value.drid;

    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patchDateAndTime(receivedEntry);
      modalRef.close();
    })

    modalRef.componentInstance.closeModal.subscribe((val) => {
      modalRef.dismiss();
    })

    modalRef.result.then(
      (result) => {
        console.log("result", result);
      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  patchDateAndTime(dateTime) {
    this.scheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(moment(dateTime).format('YYYY')), month: parseInt(moment(dateTime).format('MM')), day: parseInt(moment(dateTime).format('DD')) },
      startTime: { hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) },
      endTime: Utils.constructTime({ hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) }, Utils.defaultEndTimeAddon)
    })
    this.dateTimeChangeEvent();
  }

  tacChecked(evt) {
    let target = evt.target;
    this.termsAndCondition = target.checked;
  }
  resetfn() {
    this.spinner.show();
    window.location.reload();
  }
  refresh(appointment) {
    this.toDate = null;
    this.fromDate = null;
    appointment['name'] = '';
    appointment['contact'] = null;
    appointment['city'] = '';
    appointment['fromDate'] = null;
    appointment['toDate'] = null;


  }

}